/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, kebabCase } from 'lodash';
import { getServerData } from 'utils/getServerData';

const SESSION_DATA_KEY = 'sfmc.tracking';
const SERVER_DATA_KEY = 'SFMC_URL';

// HINT: ConversionTag is based on Salesforce Marketing Conversion.
//       Official docs at: https://help.salesforce.com/s/articleView?id=sf.mc_es_java_conv_samples.htm&language=en_US&type=5
const ConversionTag = ({
  name,
  action,
  traceId,
  convId = Math.ceil(performance.now()),
  alias = kebabCase(`${name}.${action}`),
  index = 1,
  email,
  ...rest
}) => {
  // HINT: Session storage item is generated via src/app/utils/ssr/responseHtml.js#salesforceTrace.
  const session = JSON.parse(sessionStorage.getItem(SESSION_DATA_KEY));
  // HINT: Marketing is not tracking.
  if (isEmpty(session)) {
    return null;
  }

  const src = getServerData(SERVER_DATA_KEY);
  const xml = `
      <system>
        <system_name>tracking</system_name>
        <action>conversion</action>
        <member_id>${session.mid}</member_id>
        <job_id>${session.j}</job_id>
        <sub_id>${session.sfmc_sub || session.sfmc_id}</sub_id>
        <email>${session.e || session.mcparam || email}</email>
        <list>${session.l}</list>
        <BatchID>${session.jb}</BatchID>
        <original_link_id>${session.u}</original_link_id>
        <conversion_link_id>${session.convid || convId}</conversion_link_id>
        <trace_link_id>${traceId || session.convid || convId}</trace_link_id>
        <link_alias>${alias}</link_alias>
        <display_order>${index}</display_order>
        <data_set>
        </data_set>
      </system>`;

  return (
    <img alt="" src={`${src}?xml=${xml}`} width="1" height="1" {...rest} />
  );
};

ConversionTag.propTypes = {
  name: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  traceId: PropTypes.string,
  alias: PropTypes.string,
  index: PropTypes.number,
  email: PropTypes.string,
};

export default ConversionTag;

// HINT: Possible props that are passed Query String args.
// Official docs at: https://help.salesforce.com/s/articleView?id=sf.mc_es_java_conv_samples.htm&language=en_US&type=5
// Query Params:
// sfmc_id OR sfmc_sub -> Salesforce marketing conversion id Or Subscriber id.
// e OR mcparam        -> Custmer's e-mail address.
// j                   -> Job id.
// l                   -> List id.
// jb                  -> Batch id.
// u                   -> Original link id Or Url id.
// mid                 -> Member id.
// convid              -> Conversion id or trace id of this transaction.
export const salesforceTrace = () => `
    <!-- Salesforce Marketing Conversion tag. -->
    <script language="javascript">
      const s = Object.fromEntries(new URLSearchParams(window.location.search).entries());
      if (s.sfmc_id || s.sfmc_sub) { sessionStorage.setItem('${SESSION_DATA_KEY}', JSON.stringify(s)); }
    </script>
    <!-- End Salesforce Marketing Conversion tag. -->
    `;
